import { useQuery } from '@tanstack/react-query';

import { SKILLED_NURSING_FACILITY } from 'constants/locationTypes';
import { GroupAccessMode, groupsQueryKeys, indexGroups } from 'services/api/group';

// The buildings the current user may address a referral to. Referral creation, referral
// editing, and portal-retrieval facility entry all offer exactly this set, so they share
// one query key and one cache entry rather than fetching the same list under three names.
const PARAMS = {
  accessModes: [GroupAccessMode.Allowed],
  type: SKILLED_NURSING_FACILITY,
  pageSize: 200,
  sortBy: 'name',
};

export function useAllowedFacilities() {
  const query = useQuery({
    queryKey: [...groupsQueryKeys.index, PARAMS],
    queryFn: ({ signal }) => indexGroups(PARAMS, signal),
  });

  return { facilities: query.data?.data ?? [], isPending: query.isPending };
}
